module.exports = __webpack_public_path__ + "img/vojislava-ilica-33-logo.24ae1130.svg";